import { useMemo } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useTranslation } from "react-i18next";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { renderUserName } from "utils/helpers/user";
import { renderSettingsResourceLabel } from "utils/helpers/settings";

function PersonalInformation({ user }: any) {
    const { t } = useTranslation();

    const primarySupervisor = useMemo(
        () => (user?.supervisors as any[])?.find(({ primary }: any) => primary),
        [user?.supervisors],
    );

    return (
        <SectionCard title={t("personal-information")}>
            <SectionRow label={t("employee-number")} value={user?.employeeNumber} />
            <SectionRow label={t("badge-id")} value={user?.badgeId} />
            <SectionRow label={t("first-name")} value={user?.firstName} />
            <SectionRow label={t("middle-name")} value={user?.middleName} />
            <SectionRow label={t("last-name")} value={user?.lastName} />
            <SectionRow
                label={t("gender")}
                value={user?.gender ? renderSettingsResourceLabel(user.gender) : undefined}
            />
            <SectionRow
                label={t("ethnicity")}
                value={user?.race ? renderSettingsResourceLabel(user.race) : undefined}
            />
            <SectionRow
                label={t("supervisor")}
                value={primarySupervisor ? renderUserName(primarySupervisor) : undefined}
            />
            <SectionRow label={t("personal-email")} value={user?.email} />
            <SectionRow label={t("work-email")} value={user?.email} />
            <SectionRow
                label={t("phone-number")}
                value={user?.phone
                    ? parsePhoneNumberFromString(
                        user.phone.startsWith("+") ? user.phone : `+${user.phone}`)?.formatInternational()
                    : undefined}
            />
        </SectionCard>
    );
}

export default PersonalInformation;
